import styled from '@emotion/styled'
import TemplateHero from '@/components/templates/TemplateHero'
import TemplateHeader from '../../../components/templates/TemplateHeader'
import TemplateNavigation from '../../../components/templates/TemplateNavigation'
import TemplateButton from '../../../components/templates/TemplateButton'

const Layout = styled.section``

Layout.Header = styled(TemplateHeader)`
  display: flex;
  height: 80px;
  width: 100%;
  border-top-color: #ffd0b3; 
  border-top-width: 1px;
`

Layout.Logo = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin: 0 auto;
`

Layout.LogoImage = styled.img`
  height: 70px;
  justify-self: flex-start;
`

Layout.LogoText = styled.span`
  font-size: 22px;
  font-weight: 700;
`

Layout.Navigation = styled(TemplateNavigation)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

Layout.Link = styled.span`
  margin-left: 10px;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 15px;
  color: #0c0c0c;
`

Layout.Hero = styled(TemplateHero)`
  overflow: hidden;
  position: relative;
`

Layout.HeroContainer = styled.div`
  display: flex;
  padding: 8em 0;
  width: 100%;
  flex-wrap: wrap;
  z-index: 1;
  position: relative;
`

Layout.TitleContainer = styled.div`
  display: flex;
  flex-basis: 40%;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 1em;
  height: fit-content;
  background: #ffffff90;
  margin: auto 0 auto 3em;
  padding: 2em 0.5em;
`

Layout.Title = styled.h1`
  font-size: 42px;
  font-weight: 700;
`
Layout.Subtitle = styled.p`
  font-size: 20px;
`
Layout.CTA = styled(TemplateButton)`
  width: fit-content;
  font-size: 16px;
  font-weight: 700;
  padding: 12px 25px;
`
Layout.HeroImageContainer = styled.div`
  overflow: hidden;
  width: 50%;
`
export default Layout
